import { useQuery } from '@zg-rentals/react-query5';
import {
  MarketAnalyticsWebApiHandler_getMfRegionPerformance,
  MarketAnalyticsWebApiHandler_getMfRegionPerformance_Path,
  MarketAnalyticsWebApiHandler_getSfRegionPerformance,
  MarketAnalyticsWebApiHandler_getSfRegionPerformance_Path,
} from '@zg-rentals/ts-customer-analytics-client';

export const useGetRegionPerformance = ({
  zillowRegionId,
  isSingleFamily,
  enabled = true,
}: {
  zillowRegionId: number;
  isSingleFamily: boolean;
  enabled?: boolean;
}) => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 13);

  return useQuery({
    queryKey: [
      isSingleFamily
        ? MarketAnalyticsWebApiHandler_getSfRegionPerformance_Path
        : MarketAnalyticsWebApiHandler_getMfRegionPerformance_Path,
      { zillowRegionId, isSingleFamily },
    ],
    queryFn: () => {
      if (isSingleFamily) {
        return MarketAnalyticsWebApiHandler_getSfRegionPerformance({
          zillowRegionId: zillowRegionId,
          startDate: {
            year: startDate.getFullYear(),
            month: startDate.getMonth() + 1,
            day: startDate.getDate(),
          },
          endDate: {
            year: endDate.getFullYear(),
            month: endDate.getMonth() + 1,
            day: endDate.getDate(),
          },
        }).then((res) => {
          return res.map((marketData) => ({
            ...marketData,
            medianProspects: marketData.totalProspects / marketData.totalListings,
            medianViews: marketData.totalViews / marketData.totalListings,
            medianImpressions: marketData.totalImpressions / marketData.totalListings,
          }));
        });
      } else {
        return MarketAnalyticsWebApiHandler_getMfRegionPerformance({ zillowRegionId: zillowRegionId! });
      }
    },
    enabled: enabled,
  });
};
